(function ($) {
    $(document).ready(function () {
        var width = $('.tcu_form').width();
        $('body:not(.page-template-financing-tco) .slider-input').jRange({
            from: 10,
            to: 40,
            step: 5,
            scale: ['10k','20k','30k','40k'],
            format: '%s,000 km',
            width: width,
            showLabels: true,
            snap: true,
            onstatechange: function(value){getSliderValue(value);}
        });
        var width_tco = $('.tcu_form .slider-input-tco-wrap').width();
        $('.slider-input-tco').jRange({
            from: 10,
            to: 40,
            step: 5,
            scale: ['10k','','20k','','30k','','40k'],
            format: '%s,000',
            width: width_tco,
            showLabels: true,
            snap: true,
            onstatechange: function(value){getSliderValue(value);}
        });

        
        function getSliderValue(value){
            $('.tcu_page form.tcu_form .slider-input-tco-pointer-label').html(value+',000');
            if(value == 10){
                $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('inside last').addClass('first');
            }
            else if(value > 10 && value < 40){
                $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('first last').addClass('inside');
            }
            else if(value == 40){
                $('.tcu_page form.tcu_form .slider-container.theme-green .back-bar .pointer-label').removeClass('first inside').addClass('last');
            }
            dataLayer.push({
                'step':'choose-km',
                'funnelName':'Calculator',
                'model':$('.tcu_page form.tcu_form select.tcu_select.tcu_brands').val(),
                'subModel':$('.tcu_page form.tcu_form select.tcu_select.tcu_models').val(),
                'event':'changeStep'
            });
            $('.tcu_page .slider-container .pointer.high').attr({
                'aria-label':$('.tcu_page .pointer-label.high').html(),
                'aria-valuenow':parseInt($('.tcu_page .slider-input').val())*1000
            });
            $('.tcu_before_calculate .error_result').hide();
            //console.log(dataLayer);
        }
    });
})(jQuery);


// WEBPACK FOOTER //
// assets/scripts/client/slider-range.js